import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';


const ProfileMenu = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  if (!isOpen) return null;

  const handleSignOut = async () => {
    try {
      console.log('Sign out button clicked');
      
  
      // Call the signOut function from AuthContext
      await signOut();
      
      // The navigation is already handled in signOut(), but as a fallback:
      console.log('Manual navigation fallback');
      setTimeout(() => {
        navigate('/', { replace: true });
        window.location.reload(); // Force reload as last resort
      }, 500);
      
    } catch (error) {
      console.error('Error signing out:', error);
      // Still try to navigate even on error
      navigate('/', { replace: true });
    } finally {
      // Make sure menu closes
      onClose();
    }
  };
  const handleMyPlans = () => {
    navigate('/upgrade');
    onClose();
  };

  const handleTermsAndService = () => {
    navigate('/terms'); // internal client-side navigation
    onClose();
  };

  const handlePrivacyPolicy = () => {
    navigate('/privacy');
    onClose();
  };



  return (
    <MenuOverlay onClick={onClose}>
      <MenuContainer onClick={(e) => e.stopPropagation()}>
        <MenuItem onClick={handleMyPlans}>
          <MenuIcon>
            <RocketIcon />
          </MenuIcon>
          <MenuText>My Plans</MenuText>
        </MenuItem>
        <MenuItem onClick={handleTermsAndService} >
          <MenuIcon>
            <DocumentIcon />
          </MenuIcon>
          <MenuText>Terms And Conditions</MenuText>
        </MenuItem>
        <MenuItem onClick={handlePrivacyPolicy} >
          <MenuIcon>
            <DocumentIcon />
          </MenuIcon>
          <MenuText>Privacy policy</MenuText>
        </MenuItem>
        <MenuItem onClick={handleSignOut}>
          <MenuIcon>
            <SignOutIcon />
          </MenuIcon>
          <MenuText>Sign out</MenuText>
        </MenuItem>
      </MenuContainer>
    </MenuOverlay>
  );
};

const RocketIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5 6.5C15 8 14 10.5 14 10.5C14 10.5 11.5 11.5 10 10C8.5 8.5 9.5 6 9.5 6C9.5 6 12 5 13.5 6.5Z" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19.5 4.5C19.5 4.5 20 1 16 3C12 5 4 13 4 13L7.5 14.5L9 18C9 18 17 10 19 6C21 2 19.5 4.5 19.5 4.5Z" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 13L2 20L4.5 21.5L6 20.5L5 19L7 17L8.5 18.5L9 18" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const DocumentIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 2V8H20" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 13H8" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 17H8" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 9H8" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const SignOutIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 8V6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4H5C4.46957 4 3.96086 4.21071 3.58579 4.58579C3.21071 4.96086 3 5.46957 3 6V18C3 18.5304 3.21071 19.0391 3.58579 19.4142C3.96086 19.7893 4.46957 20 5 20H12C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0391 14 18.5304 14 18V16" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 12H21M21 12L18 9M21 12L18 15" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const MenuOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background-color: transparent;
`;

const MenuContainer = styled.div`
  position: fixed;
  top: 60px;
  right: 20px;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  width: 270px;
  padding: 8px 0;
  z-index: 100000;
  border: 1px solid rgba(0, 0, 0, 0.05);
`;

const MenuItem = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 24px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #f5f5f5;
  }
`;

const MenuIcon = styled.span`
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  color: #555;
`;

const MenuText = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #333;
  font-family: 'Space Grotesk', sans-serif;
`;

export default ProfileMenu; 